import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/cycleCountApproval';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const cycleCountApproval = ({ t }) => (
  <Container>

   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

cycleCountApproval.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(cycleCountApproval);
